import { render, staticRenderFns } from "./createLesson.vue?vue&type=template&id=05cb0fa8&"
import script from "./createLesson.vue?vue&type=script&lang=js&"
export * from "./createLesson.vue?vue&type=script&lang=js&"
import style0 from "./createLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports